// extracted by mini-css-extract-plugin
export default {"gridRow":"CSVItem_gridRow__B2Xy0"};